import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchCollectionMgmtBibColBulkRemovalRequest,
  BatchCollectionMgmtBibColBulkRemovalRequestToJSON
} from '@/api/models/batch/BatchCollectionMgmtBibColBulkRemovalRequest'
import {
  BatchCollectionMgmtBibColBulkRemovalPageLoadResult,
  BatchCollectionMgmtBibColBulkRemovalPageLoadResultFromJSON
} from '@/api/models/batch/BatchCollectionMgmtBibColBulkRemovalPageLoadResult'

export class BatchCollectionMgmtBibColBulkRemovalApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchCollectionMgmtBibColBulkRemovalPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchCollectionMgmtBibColBulkRemovalPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createCollectionMgmtBibColBulkRemoval(
    request: BatchCollectionMgmtBibColBulkRemovalRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/collection-management/bibliography-collection-bulk-removal`,
      BatchCollectionMgmtBibColBulkRemovalRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
